export default "__VITE_ASSET__CzMiohvD__"